import { Component, Prop} from 'vue-property-decorator';
import * as tsx from 'vue-tsx-support';

import './style.less';

interface IDeviceNumber {
  cid?: string
}

@Component
export default class DeviceNumber  extends tsx.Component<IDeviceNumber > {
  
  @Prop() public cid ? : string
  
  render() {
    return (
      <div class='deviceNumber-container'>
        <div class='title'>当前云手机设备号</div>
        <div class='subtitle'>{this.$props.cid}</div>
      </div>
    )
  }
  
}